import { z } from 'zod';
import { ADDRESS_SOURCES, LOCALES } from '../enums.js';
/**
 * Деньги передаются строкой, а не числом: `numeric(12,2)` из PostgreSQL,
 * попав в JSON-число, становится float и теряет точность на копейках.
 */
export const money = z
    .string()
    .regex(/^\d{1,10}(\.\d{1,2})?$/, 'Сумма должна быть числом с двумя знаками после точки');
export const latitude = z.number().min(-90).max(90);
export const longitude = z.number().min(-180).max(180);
export const localeSchema = z.enum(LOCALES);
export const addressSourceSchema = z.enum(ADDRESS_SOURCES);
/** Дата слота: календарный день без времени. */
export const dateOnly = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Ожидается дата в формате ГГГГ-ММ-ДД');
/** Время слота с точностью до минуты. */
export const timeOnly = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Ожидается время в формате ЧЧ:ММ');
export const idParam = z.object({
    id: z.coerce.number().int().positive(),
});
/**
 * Курсорная пагинация. Смещение не используется: на растущем списке заказов
 * оно пропускает и дублирует записи между страницами.
 */
export const paginationQuery = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(20),
    cursor: z.string().optional(),
});
export function paginated(item) {
    return z.object({
        items: z.array(item),
        next_cursor: z.string().nullable(),
        has_more: z.boolean(),
    });
}
/** Адрес, передаваемый вместе с заказом без сохранения в профиль. */
export const inlineAddress = z.object({
    lat: latitude,
    lon: longitude,
    source: addressSourceSchema,
    address_text: z.string().min(1).max(500),
    house: z.string().max(50).optional(),
    entrance: z.string().max(50).optional(),
    floor: z.string().max(50).optional(),
    apartment: z.string().max(50).optional(),
    landmark: z.string().max(200).optional(),
});
//# sourceMappingURL=common.js.map